// = Libs =
import { components, ControlProps } from 'react-select';

// = Styles =
import classes from '../select.module.scss';
import clsx from 'clsx';

const SelectControl = (props: ControlProps<any, any> & { addClass?: string }) => {
  return <components.Control className={clsx(classes.control, props.addClass)} {...props} />;
};

export default SelectControl;
